import { CustomLogin } from 'vendor/infrastructure/custom_requests/login';
import { updateSending } from 'vendor/application/disptach';
import $ from 'jquery';

const BASE = process.env.REACT_APP_URL_BACK;

function join(...parts) {
  return parts
    .map((p, i) => (i === 0 ? String(p).replace(/\/+$/, '') : String(p).replace(/^\/+/, '')))
    .join('/');
}

export class CustomRequest {
  constructor(method, url, body, token, props) {
    this.base_url = BASE;
    this.method = method;
    this.url = url;
    this.body = body;
    this.token = token;
    this.props = props;
    this.count = 0;
  }

  buildV2Url() {
    const v2Base = String(this.base_url).replace(/v1\/?$/, 'v2/');
    return join(v2Base, this.url);
  }

  async make_request(version = 'v1') {
    const url = version === 'v2' ? this.buildV2Url() : join(this.base_url, this.url);

    try {
      const headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      if (this.token?.access) headers['Authorization'] = `Bearer ${this.token.access}`;

      const response = await $.ajax({
        url,
        type: this.method,
        data: this.body ? JSON.stringify(this.body) : undefined,
        dataType: 'json',
        headers,

      });
      return { response, status: 200 };
    } catch (jqXHR) {
      const status = jqXHR?.status ?? 500;
      const rt = jqXHR?.responseText;
      const rj = jqXHR?.responseJSON;
      const hdrs = (jqXHR?.getAllResponseHeaders && jqXHR.getAllResponseHeaders()) || '';
      const contentType = /content-type:\s*(.*)/i.exec(hdrs)?.[1]?.trim();

      if (typeof rt === 'string' && /<html/i.test(rt)) {

        console.error('[REQ][HTML]', { url, status, contentType, preview: String(rt).slice(0, 200) });
        return { response: 'Frontend HTML received (wrong target URL)', status: 502 };
      }

      let message = 'Unexpected error occurred';
      if (rj?.message) {
        message = rj.message;
      } else if (typeof rt === 'string' && rt.trim().length) {
        try { message = JSON.parse(rt)?.message ?? message; } catch { /* pudo ser HTML */ }
      }

      return { response: message, status };
    }
  }

  async action(version = 'v1') {
    const first = await this.make_request(version);
    this.count += 1;
    if (this.count > 3) {
      throw new Error('Too many access requests.');
    }

    switch (first.status) {
      case 200:
        this.props.dispatch(updateSending(false));
        return first.response;

      case 401: {
        const request = new CustomLogin({ refresh: this.token?.refresh }, 'token/refresh/', this.props);
        const req = await request.make_request_refresh();
        this.token = req;
        return this.action(version);
      }

      case 502:
        this.props.dispatch(updateSending(false));
        throw new Error('Request hit the frontend (HTML), not the backend. Check the this.url path and use an absolute URL.');

      case 500:
        this.props.dispatch(updateSending(false));
        throw new Error('Error 500 Internal Server Error');

      default:
        this.props.dispatch(updateSending(false));
        throw new Error(first.response);
    }
  }
}